import { CommonAPI } from "../Client";

export const getCurrentTenantAPI = (tenantId) => {
  return CommonAPI.get(`/tenants/${tenantId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateTenantAPI = (payload) => {
  return CommonAPI.put("/tenants", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const updateTenantStatusAPI = (payload) => {
  return CommonAPI.put(`/tenants/status/${payload.statusId}/${payload.tenantId}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getAllTenantAPI = (payload) => {
  return CommonAPI.get(`/tenants?page=${payload?.page}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const triggerTenantBuildAPI = () => {
  const endpoint = "/tenants/publish";

  return CommonAPI.post(endpoint)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};

export const getTenantPublishStatusAPI = () => {
  return CommonAPI.get("/tenants/publish/status")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error.response;
    });
};
